import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQuery } from "@/redux/baseQuery";
import { transformAccounts } from "./helpers";
import { GetAccountsResponse, AttachClientToProviderParams, DetachClientFromProviderParams } from "./types";

export const accountApi = createApi({
  reducerPath: "accountApi",
  baseQuery,
  endpoints: (builder) => ({
    getAccounts: builder.query<GetAccountsResponse, void>({
      query: () => "/v3/account-management",
      transformResponse: transformAccounts,
      providesTags: ["Account"],
    }),
    attachClientToProvider: builder.mutation<void, AttachClientToProviderParams>({
      query: ({ clientId, providerId }) => ({
        url: `/v3/account-management/${clientId}/providers/${providerId}/application/attach`,
        method: "POST",
        body: { role: "client", responses: [] },
      }),
    }),
    detachClientFromProvider: builder.mutation<void, DetachClientFromProviderParams>({
      query: ({ clientId, providerId }) => ({
        url: `/v3/account-management/${clientId}/providers/${providerId}/application/detach`,
        method: "POST",
      }),
      invalidatesTags: ["Account"],
    }),
  }),
  tagTypes: ["Account"],
});

export const { useLazyGetAccountsQuery, useAttachClientToProviderMutation, useDetachClientFromProviderMutation } = accountApi;
